<template>
  <div class="global-loading-site">
    <transition name="loading">
      <wownow-loading color="#1989fa" class="global-loading" v-if="show" />
      <!-- <van-loading color="#1989fa" class="global-loading" v-if="show" /> -->
    </transition>
    <div class="global-loading-background" v-if="show" />
  </div>
</template>

<script>
// import { Loading } from 'vant';

// Vue.use(Loading);
import _loading from './_loading';
export default {
  components: {
    [_loading.name]: _loading
  },
  data() {
    return {
      show: false
    }
  },
  mounted() {
    Vue.filter('loading', (isShow) => {
      this.show = !!isShow;
    });
    Vue.filter('get-loading', () => this.show);
  }
}
</script>

<style lang="stylus" scoped>
  .global-loading {
    z-index: 999999;
    position: fixed !important;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .loading-enter-active, .loading-leave-active {
    transition: opacity .3s;
  }
  .loading-enter, .loading-leave-to {
    opacity: 0;
  }
  .global-loading-background {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 9999;
  }
</style>
